module.exports = __webpack_public_path__ + "img/supplier-pic.56a868ce.jpg";